<template>
<a-modal
  width="700px"
  title="标签管理"
  v-model:visible="visible">
  <a-form ref="form"
    class="form"
    layout="inline"
    :model="form"
    :rules="rules">
    <a-form-item label="名称" name="chineseInstructions">
      <a-input v-model:value="form.chineseInstructions" autocomplete="off"></a-input>
    </a-form-item>
  </a-form>
  <template #footer>
    <a-button key="back" @click="visible = false">
      取消
    </a-button>
    <a-button key="submit" type="primary" @click="handleSubmit">
      保存
    </a-button>
  </template>
</a-modal>
</template>
<script>
import { addTagLabel, updateTagLabel } from '@/api/tagLabel'
export default {
  props: {
    dialogType: {
      type: String,
      default: 'add'
    },
    currentItem: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      visible: false,
      actionType: 'add',
      form: {
        chineseInstructions: ''
      },
      rules: {
        chineseInstructions: [
          { required: true, message: '请填写名称', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open () {
      this.visible = true
      this.$nextTick(() => {
        this.actionType = this.dialogType
        this.form = {
          chineseInstructions: ''
        }
        if (this.actionType === 'edit') {
          this.form = {
            id: this.currentItem.id,
            chineseInstructions: this.currentItem.chineseInstructions
          }
        }
      })
    },
    handleSubmit () {
      const action = this.actionType === 'add' ? addTagLabel : updateTagLabel
      this.$refs.form.validate().then(() => {
        action(this.form).then(res => {
          this.$message.success('操作成功')
          this.$emit('update')
          this.visible = false
        }).catch(e => {
          this.$message.error('操作失败')
        })
      })
    }
  }
}
</script>
<style lang="less" scoped>
.form {
  .ant-form-item {
    // margin: 10px 0;
    width: 280px;
  }
}
</style>
